import { ChapterTitle } from '../elements/atoms/chapterTitle/ChapterTitle';
import { HeroText } from '../elements/atoms/heroText/HeroText';
import { PageTitle } from '../elements/atoms/pageTitle/PageTitle';
import { Paragraph } from '../elements/atoms/paragraph/Paragraph';
import { ParagraphTitle } from '../elements/atoms/paragraphTitle/ParagraphTitle';
import { Article } from '../elements/molecules/article/article';
import { Container } from '../elements/molecules/container/Container';
import { Main } from '../elements/molecules/main/Main';
import { PageSection } from '../elements/molecules/pageSection/PageSection';
import { Footer } from '../elements/organisms/footer/Footer';
import { Header } from '../elements/organisms/header/Header';
import { PageWrapper } from '../elements/organisms/pageWrapper/PageWrapper';

export function Cookies() {
    return (
        <PageWrapper fullHeight>
            <Header hasBackbutton />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>
                            <PageTitle>Cookies</PageTitle>
                            <HeroText>
                                Bij Ksyos gebruiken we geen tracking cookies. Daarom zie je ook geen irritante cookie
                                melding voor toestemming. Dat scheelt.
                            </HeroText>
                        </Article>
                    </PageSection>
                    <PageSection bgColor="white">
                        <Article>
                            <ChapterTitle>Welk soort cookies gebruiken we wel?</ChapterTitle>
                            <Paragraph>
                                Ksyos gebruikt alleen technische, functionele en analytische cookies. Deze maken geen
                                inbreuk op je privacy. Een cookie is een klein tekstbestand dat bij het eerste bezoek
                                aan de website wordt opgeslagen op je computer, tablet of smartphone. De cookies die wij
                                gebruiken zijn noodzakelijk voor de technische werking van de website en dienen ten
                                gunste van je gebruiksgemak. Ze zorgen ervoor dat de website naar behoren werkt en
                                onthouden bijvoorbeeld je voorkeursinstellingen. Ook kunnen wij hiermee onze website
                                optimaliseren. Je kunt je afmelden voor cookies door je internetbrowser zo in te stellen
                                dat deze geen cookies meer opslaat. Daarnaast kun je ook alle informatie die eerder is
                                opgeslagen via de instellingen van je browser verwijderen.
                            </Paragraph>
                        </Article>
                        <Article>
                            <ParagraphTitle>Inzet van externe tools en scripts</ParagraphTitle>
                            <Paragraph>
                                Wij maken gebruik van Datadog voor technische en analytische doeleinden zoals het
                                verbeteren van de werking en het gebruiksgemak van MijnKsyos. Deze gegevens gebruiken we
                                niet voor andere doeleinden, en ze worden veilig in de EU opgeslagen. Wij gebruiken geen
                                andere externe scripts of tracking cookies.
                            </Paragraph>
                        </Article>
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}
